import Typography from "@mui/material/Typography";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    txt?: string | null,
    propertyName?: string,
    children?: JSX.Element,
    type?: string,
    icon?: JSX.Element,
    hasFocusedStyle?: boolean,
    displayContents?: boolean,
    handleClickLink?: () => void
}

export enum type {
    FOOTER = "footer",
    BREADCRUMB = "breadcrumb",
    APP_MENU_TEASER = "appMenuTeaser"
}

export const textDecorationStyle = {
    textDecoration: "underline",
    textDecorationThickness: "2px",
    textUnderlineOffset: "4px",
}

function CCOLinkText(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const theme = useTheme();
    let linkStyle;
    let linkColor = "primary.main";
    if (props.type && props.type === type.FOOTER) {
        linkColor = "footerLink.main";
        linkStyle = {
            typography: theme.typography.body2,
            display: 'inline-block',
            fontFamily: '"HelveticaNeueLTStd-Bd", Helvetica, Arial, sans-serif',
            textDecoration: 'none',
            py: 2,
            '&:hover': textDecorationStyle
        };
    } else if (props.type && props.type === type.BREADCRUMB) {
        linkStyle = {
            typography: theme.typography.subtitle2,
            textDecoration: 'none',
            '&:hover': {
                color: theme.palette.primary.dark,
                textDecorationColor: theme.palette.primary.dark
            }
        }
    } else {
        linkStyle = {
            typography: 'linkLabel',
            fontSize: props.type === type.APP_MENU_TEASER ? 'var(--font-size-menu-item)' :
                undefined,
            display: props.displayContents ? 'contents' : undefined,
            '&:hover': {
                ...textDecorationStyle,
                cursor: 'pointer'
            }
        };
    }

    if (props.txt) {
        return (
            <Typography
                component={'div'}
                className={props.hasFocusedStyle ? 'show-more-with-focus' : undefined}
                onClick={props.handleClickLink}
                {...metaDataProperty(isPreview, props.propertyName)}
                sx={{
                    color: linkColor,
                    ...linkStyle,
                    width: 'max-content'
                }}>
                {props.txt}
            </Typography>
        );
    } else if (props.children) {
        return (
            <Typography
                component={'div'}
                {...metaDataProperty(isPreview, props.propertyName)}
                onClick={props.handleClickLink}
                sx={[{
                    color: linkColor
                }, ...(Array.isArray(linkStyle) ? linkStyle : [linkStyle])]}>
                {props.icon}
                {props.children}
            </Typography>
        );
    } else {
        return null;
    }
}

export default CCOLinkText